import React                     from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'

import SmartForm      from './smart_form/main'
import ModalDialog    from './modal_dialog'
import HorizontalForm from './horizontal_form'

import './admin_form.sass'

export default class AdminForm extends SmartForm
  createText: 'Vytvořit'
  updateText: 'Upravit'

  render: ->
    action = if @props.action == 'create' then @createText else @updateText
    form   = <HorizontalForm className='admin-form'>
               {@errorDetailAlert()}
               {@formInputs()}
             </HorizontalForm>

    <ModalDialog title={"#{action} #{@model.accusativeName}"} body={form} footer={@buttons()} />

  buttons: ->
    <ButtonToolbar className='pull-right'>
      <Button onClick={@props.cancel}>Zrušit</Button>
      {@submitButton()}
    </ButtonToolbar>
